import { createUseStyles } from 'react-jss'

export const styles = {
  clickable: {
    cursor: 'pointer'
  }
}

export const useStyles = createUseStyles(styles)
